import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';
import MDSpinner from 'react-md-spinner';

class BlockingSpinner extends React.Component {
  render() {
    const loadingMessage = this.props.loading.loadingMessage || 'Processing';

    return (
      <Background>
        <SpinnerContainer>
          <MDSpinner
            color1={'#fff'}
            color2={'#fff'}
            color3={'#fff'}
            color4={'#fff'}
            size={30}
            data-testid={'blockingSpinner'}
          />
          <Message>{loadingMessage}</Message>
        </SpinnerContainer>
      </Background>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.ui.loading,
});

export default connect(mapStateToProps)(BlockingSpinner);

const Background = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  right: 0;
  top: 0;
  left: 0;
  background-color: rgba(48, 56, 73, 0.8);
  z-index: 900;
`;

const SpinnerContainer = styled.div`
  text-align: center;
`;

const Message = styled.p`
  color: white;
  margin-top: 20px;
  font-size: 14px;
`;
